/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState } from 'react';
import classNames from '../helpers/classNames.js';
import ModalContent from './private/modal-sheet-utils/ModalContent.js';

/**
 *
 * @param {ModalSheetProps} modalSheetProps
 * @returns {JSX.Element|null}
 * @constructor
 */
const ModalSheet = ({
  Content,
  contentProps,
  isBlockingUI,
  dispatchHide,
  willHide
}) => {
  const [node, setNode] = useState();
  const handleRef = useCallback(n => {
    // If node is present, we can focus on it
    if (n) {
      n.focus();
    }
    setNode(n);
  }, [setNode]);
  const handleCloseModal = useCallback(event => {
    // Modal type is marked as blocking one. No close on layer click.
    if (isBlockingUI) {
      return;
    }
    if (event.key === 'Escape' && !willHide) {
      dispatchHide();
    }
  }, [dispatchHide, isBlockingUI, willHide]);

  // Watch out!
  // This is never called while modal is fading in.
  // There's an animation for pointer events in CSS preventing that: mainFadeIn
  const handleGlobalClick = useCallback(event => {
    // Modal type is marked as blocking one. No close on layer click.
    if (isBlockingUI) {
      return;
    }
    // Clicked element is not "modal" but some child.
    if (event.target !== node) {
      return;
    }
    if (willHide) {
      // Hiding anyway;
      return;
    }
    dispatchHide();
  }, [node, dispatchHide, willHide, isBlockingUI]);
  useEffect(() => {
    const body = document.querySelector('body');
    if (!body) {
      console.warn('Could not find body!');
      return;
    }
    if (Content) {
      body.style.top = `-${window.scrollY}px`;
      body.style.position = 'fixed';
      body.style.maxWidth = '100%';
      return;
    }

    // Without this mumbo jumbo scroll jumps to top when modal closes due to changes in position.
    if (body.style.position !== 'fixed') {
      // Skip when body is not fixed.
      // It means no modal was ever opened yet!
      return;
    }
    const scrollY = body.style.top;
    body.style.position = '';
    body.style.top = '';
    body.style.maxWidth = '';
    window.scrollTo(0, parseInt(scrollY || 0, 10) * -1);
  }, [Content]);
  if (!Content) {
    return null;
  }
  const modalClassNames = classNames('ebds-modal', {
    '--will-hide': willHide
  });

  /* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
  return /*#__PURE__*/React.createElement("div", {
    className: modalClassNames,
    ref: handleRef,
    onClick: handleGlobalClick,
    onKeyDown: handleCloseModal,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Content, contentProps));
};
ModalSheet.Content = ModalContent;
export default ModalSheet;